import React from 'react';
import { Merchandiser } from '../../../redux/composableDevice/model/Merchandiser.model';
import { Box } from '@mui/material';
import ChannelConnection from '../../MerchandiserDetailPage/Channel/ChannelConnection';

export const DeviceControlUnitsInformation = (props: {
  merchandiser: Merchandiser;
}) => {
  const { merchandiser } = props;
  const filteredChannels =
    merchandiser?.channels.filter(
      (channel) =>
        channel?.channelType !== 'action' && channel?.channelType !== 'event'
    ) || [];

  return (
    <Box
      display={'grid'}
      gridTemplateColumns={{
        xs: '1fr',
        sm: '1fr 1fr',
        md: 'repeat(3, 1fr)',
        lg: 'repeat(4, 1fr)',
      }}
      gap={'0.8rem'}
      gridAutoRows={'1fr'}
    >
      {filteredChannels.map((channel, indexChannel) => (
        <ChannelConnection
          channel={channel}
          merchandiser={merchandiser}
          key={indexChannel}
        ></ChannelConnection>
      ))}
    </Box>
  );
};
